import * as React from "react"
import Svg, {Path} from "react-native-svg"
import {Colors} from "../colors";
import {useContext} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";

export default function CategoryIndicator(props: any) {
    const colors = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color)
    return (
        <Svg
            width={12}
            height={5}
            viewBox="0 0 12 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <Path
                d="M1.06.884A.5.5 0 011.382 0h9.238a.5.5 0 01.32.884L6.32 4.734a.5.5 0 01-.64 0L1.06.883z"
                fill={colors.get("primaryColor") as string}
            />
        </Svg>
    )
}
